module.exports = __webpack_public_path__ + "static/media/OFICategory.1dea53d0.pdf";